/*!
 * c-modal — wraps a native <dialog> element with open/close hooks.
 *
 * USAGE
 *   <button data-c-modal-open="success-modal">Open</button>
 *   <c-modal id="success-modal">
 *     <dialog>
 *       <button data-c-modal-close aria-label="Close">×</button>
 *       <div class="c-modal__body">Content</div>
 *     </dialog>
 *   </c-modal>
 *
 * Native <dialog> provides focus trap, escape-to-close, and inert page behind.
 * c-modal adds: backdrop click closes, programmatic open/close, custom events.
 */
(function () {
  if (window.customElements && customElements.get('c-modal')) return;

  class CModal extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      // Bind closers
      this.querySelectorAll('[data-c-modal-close]').forEach(b =>
        b.addEventListener('click', () => this.close())
      );
      // Backdrop click closes
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close();
      });
    }
    open() {
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      this.dispatchEvent(new CustomEvent('open'));
    }
    close() {
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
      this.dispatchEvent(new CustomEvent('close'));
    }
  }
  customElements.define('c-modal', CModal);

  // Global click handler for [data-c-modal-open="<id>"] triggers
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-c-modal-open]');
    if (!trigger) return;
    const id = trigger.getAttribute('data-c-modal-open');
    const modal = document.getElementById(id);
    if (modal && modal.tagName === 'C-MODAL') {
      e.preventDefault();
      modal.open();
    }
  });
})();
